"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
;
function formatGqlOptions(options) {
    return lodash_1.default.map(options, (v, k) => {
        let valueString;
        if (lodash_1.default.isPlainObject(v)) {
            valueString = `{${formatGqlOptions(v)}}`;
        }
        else if (lodash_1.default.isNil(v)) {
            valueString = 'null';
        }
        else if (v[1] == 'x' || lodash_1.default.isNaN(parseFloat(v.toString()))) {
            valueString = `"${v}"`;
        }
        else
            valueString = v;
        return `${k}:${valueString}`;
    }).join(',');
}
function formatGqlArgs(args) {
    return '{' + lodash_1.default.map(args, (v, k) => {
        if (v === true) {
            return k;
        }
        else {
            return `${k}${formatGqlArgs(v)}`;
        }
    }).join(' ') + '}';
}
function generateGql(name, options, args) {
    return `{${name}${Object.keys(options).length ? `(${formatGqlOptions(options)})` : ''}${formatGqlArgs(args)}}`;
}
exports.default = generateGql;
